export enum CashierTransactionType {
  In = 'in',
  Out = 'out',
}

export type CashierTransaction = {
  type: CashierTransactionType;
  amount: number;
  description: string;
};

export type CashierTransactionItem = {
  id: string;
  type: CashierTransactionType;
  amount: number;
  description: string;
  dateCreated: number;
};
